import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  constructor(private http: HttpClient, private EncDecrService: EncrDecrService) { }

  getCategoriesAPIuri: string = 'event/categories';

  getAllCategories() {
    return this.http.get(environment.apiURI + this.getCategoriesAPIuri).toPromise()
  }
  addCategory(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'admin/category/add', data, { headers: headers_object }).toPromise();
  }
  
  removeCategory(category) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'admin/category/delete/'+category, {}, { headers: headers_object }).toPromise();
  }
}
